"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");
/**
 * Marks recalculation process (alert) as initiated from release detail for all release parts.
 *
 * @author Jan Prokop
 */


var RecalculationInitiatedFromRelease =
/*#__PURE__*/
function (_ValidationResultFlag) {
  _inherits(RecalculationInitiatedFromRelease, _ValidationResultFlag);

  function RecalculationInitiatedFromRelease() {
    _classCallCheck(this, RecalculationInitiatedFromRelease);

    return _possibleConstructorReturn(this, _getPrototypeOf(RecalculationInitiatedFromRelease).apply(this, arguments));
  }

  _createClass(RecalculationInitiatedFromRelease, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return RecalculationInitiatedFromRelease;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.RecalculationInitiatedFromRelease = RecalculationInitiatedFromRelease;
RecalculationInitiatedFromRelease.TAG = ValidationResultFlag_1.ValidationResultFlag.register(RecalculationInitiatedFromRelease);
RecalculationInitiatedFromRelease.INSTANCE = new RecalculationInitiatedFromRelease();